var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_64007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.7002C10.1217 16.7002 12.1566 15.8573 13.6569 14.357C15.1571 12.8568 16 10.8219 16 8.7002C16 6.57846 15.1571 4.54363 13.6569 3.04334C12.1566 1.54305 10.1217 0.700195 8 0.700195C5.87827 0.700195 3.84344 1.54305 2.34315 3.04334C0.842855 4.54363 0 6.57846 0 8.7002C0 10.8219 0.842855 12.8568 2.34315 14.357C3.84344 15.8573 5.87827 16.7002 8 16.7002ZM11.5312 7.23145L7.53125 11.2314C7.2375 11.5252 6.7625 11.5252 6.47188 11.2314L4.47188 9.23145C4.17813 8.9377 4.17813 8.4627 4.47188 8.17207C4.76562 7.88145 5.24062 7.87832 5.53125 8.17207L7 9.64082L10.4688 6.16895C10.7625 5.8752 11.2375 5.8752 11.5281 6.16895C11.8187 6.4627 11.8219 6.9377 11.5281 7.22832L11.5312 7.23145Z",
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_64007"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.700195H16V16.7002H0V0.700195Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckRound);
export default __webpack_public_path__ + "static/media/green-check-round.90824cd5e69e34e2650002a540a64962.svg";
export { ForwardRef as ReactComponent };